

import React from "react";
import ReactDOM from "react-dom";
import "./styleSheets/sass/index.scss";
import { unregister } from "./util/registerServiceWorker";
import { Provider } from 'react-redux'
import store from './store'
import App from './containers/AppContainer'
import 'semantic-ui-css/semantic.min.css'
import { getBrokerUiEnvironment } from "./util/index";
import Cookie from "./services/cookie";
//import { getWebInstrumentations, initializeFaro } from '@grafana/faro-web-sdk';
//import { TracingInstrumentation } from '@grafana/faro-web-tracing';

const env = getBrokerUiEnvironment();
const faroApiKey = {
  'dev': '7652e713810f9972ff695e38d235e26e',
  'prod': '158253dded8b66da509b8b4759a45a95'
}
// if (env === 'dev' || env === 'prod') {
//     var faro = initializeFaro({
//         url: `https://faro-collector-prod-us-east-0.grafana.net/collect/${faroApiKey[env]}`,
//         app: {
//           name: window.location.hostname,
//           version: '1.0.0',
//           environment: env === 'prod'? 'production': 'development'
//         },
//         instrumentations: [
//           // Mandatory, overwriting the instrumentations array would cause the default instrumentations to be omitted
//           ...getWebInstrumentations(),
      
//           // Initialization of the tracing package.
//           // This packages is optional because it increases the bundle size noticeably. Only add it if you want tracing data.
//           new TracingInstrumentation(),
//         ],
//       });
// }
function waitForVariable( callback, maxWaitTime = 10000, checkInterval = 100) {
  const startTime = Date.now();
  
  function checkVariable() {
    if ( Cookie.get(window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN) ) {
      console.log(' Cookie.get(window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN) : ',  Cookie.get(window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN) );
      callback();
    } else if (Date.now() - startTime < maxWaitTime) {
      setTimeout(checkVariable, checkInterval);
    } else {
      console.error(`Timeout: Variable not defined within ${maxWaitTime}ms`);
      callback();
    }
  }
  
  checkVariable();
}



if (window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN == 'kxEngineBrokerToken') {
  waitForVariable( () => {
    ReactDOM.render(<Provider store={store}><App /></Provider>, document.getElementById("root"));
    unregister();
  });
} else {
  ReactDOM.render(<Provider store={store}><App /></Provider>, document.getElementById("root"));
  unregister();
}
